import { Box, Grid, Link, Stack, Typography } from '@mui/material';
import { TextLogo } from 'components/TextLogo';
import { Trans, useTranslation } from 'react-i18next';
import AppleAppStore from 'assets/apple-app-store.svg?react';
import GooglePlayStore from 'assets/google-play-store.svg?react';
import { FeatureList } from 'features/membership/components/PlanCard';
import {
  MEMBERSHIP_PLANS,
  MEMBERSHIP_PLANS_AMOUNTS,
} from 'features/membership/membership.constants';
import { AppStoreLinks } from '../../../../constants';

export const EmbeddedSupportUs = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Stack spacing={3}>
      <Box
        sx={{
          textAlign: 'center',
          '& svg': { width: 261, height: 'auto' },
        }}
      >
        <TextLogo />
      </Box>

      <Typography variant="body1">
        {t('supportUs.embedded.description')}
      </Typography>

      <Stack spacing={1}>
        <Typography variant="h3" align="center" fontWeight="fontWeightBold">
          {t('supportUs.embedded.memberSupport')}
        </Typography>

        <Typography variant="body1">
          {t('supportUs.embedded.freeSupport')}
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Stack spacing={1}>
            <Typography variant="h2">
              {t('supportUs.membership.title')}
            </Typography>

            <Stack direction="row">
              <Typography variant="body1" component="span">
                <Trans
                  i18nKey="supportUs.membership.price"
                  values={{
                    price: MEMBERSHIP_PLANS_AMOUNTS[MEMBERSHIP_PLANS.yearly],
                  }}
                >
                  <Typography
                    variant="h3"
                    component="span"
                    fontWeight={500}
                    sx={{ verticalAlign: 'top' }}
                  >
                    $
                  </Typography>
                  <Typography variant="h1" component="span">
                    24.99
                  </Typography>
                  per year
                </Trans>
              </Typography>
            </Stack>

            <FeatureList plan="yearly" />
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <Stack spacing={1}>
            <Typography variant="h2">
              {t('supportUs.proMembership.title')}
            </Typography>

            <Stack direction="row">
              <Typography variant="body1" component="span">
                <Trans
                  i18nKey="supportUs.membership.price"
                  values={{
                    price: MEMBERSHIP_PLANS_AMOUNTS[MEMBERSHIP_PLANS.proYearly],
                  }}
                >
                  <Typography
                    variant="h3"
                    component="span"
                    fontWeight={500}
                    sx={{ verticalAlign: 'top' }}
                  >
                    $
                  </Typography>
                  <Typography variant="h1" component="span">
                    99.99
                  </Typography>
                  per year
                </Trans>
              </Typography>
            </Stack>

            <FeatureList plan="pro_yearly" />
          </Stack>
        </Grid>
      </Grid>

      <Stack
        sx={{
          width: '100%',
          justifyContent: 'center',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1,
        }}
      >
        <Link
          href={AppStoreLinks.ios}
          target="_blank"
          sx={{
            pointerEvents: 'auto',
            height: '54px',
            width: 'fit-content',
          }}
        >
          <AppleAppStore width="180px" height="54px" />
        </Link>
        <Link
          href={AppStoreLinks.android}
          target="_blank"
          sx={{
            pointerEvents: 'auto',
            height: '54px',
            width: 'fit-content',
          }}
        >
          <GooglePlayStore width="180px" height="54px" />
        </Link>
      </Stack>
    </Stack>
  );
};
